app.PaymentTerminalList = app.AbstractCollection.extend({
  model: app.PaymentTerminal,

  url() {
    return '/api/v2/kiosks/payment-terminals';
  },
});
